import React from 'react';
import { DateCell } from './date-cell/index.tsx';
import EstimateCell from './estimate-cell/index.tsx';
import StatusCell from './status-cell/index.tsx';
import type { Props } from './types.tsx';
import UserCell from './user-cell/index.tsx';

export const AggregateField = ({ field, groupName }: Props) => {
	if (!field || field?.value === undefined) {
		// Leave blank if the value is not defined
		return null;
	}
	const { value, fieldKey, type } = field;

	switch (fieldKey) {
		case 'dueDate':
		case 'startDate':
		case 'targetStart':
		case 'targetEnd':
			return <DateCell fieldKey={fieldKey} groupName={groupName} value={value} type={type} />;
		case 'status':
			return <StatusCell fieldKey={fieldKey} value={value} type={type} />;
		case 'storyPoints':
		case 'timeEstimate':
			return (
				<EstimateCell fieldKey={fieldKey} groupName={groupName} rawValue={value} type={type} />
			);
		case 'assignee':
			return <UserCell fieldKey={fieldKey} rawValues={value} />;
		default:
			return null;
	}
};

export default AggregateField;
